import { render, staticRenderFns } from "./LanguageBar.vue?vue&type=template&id=2673c9ba&scoped=true&"
import script from "./LanguageBar.vue?vue&type=script&lang=js&"
export * from "./LanguageBar.vue?vue&type=script&lang=js&"
import style0 from "./LanguageBar.vue?vue&type=style&index=0&id=2673c9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673c9ba",
  null
  
)

export default component.exports